import { app } from '../../../app';
import { Controller } from './directory-integration.controller';

app.component('companyDirectoryIntegration', {
    controller: Controller,
    templateUrl: require('./directory-integration.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/directory-integration.component.js